import { map } from "lodash";

import {
  WhatsAppInstance,
  WhatsAppGroups,
  CreateInstanceWhatsAppData,
  UpdateInstanceWhatsAppData,
} from "../types/whatsApp";
import api from "./api";

export const listWhatsAppInstanceService = async (): Promise<
  WhatsAppInstance[]
> => {
  const response = await api.get("/whatsapp-v2-:stage/instances/client/list");

  return map(response.data.content, (instance: any) => ({
    ...instance,
    name: instance.nome,
  }));
};

export const checkWhatsAppInstanceConnectionService = async (
  client: number
): Promise<boolean> => {
  const response = await api.get("/whatsapp-v2-:stage/zapi/is-connected", {
    params: {
      client,
    },
  });

  return response.data.content.connected;
};

export const listWhatsAppGroupsService = async (
  client: number
): Promise<WhatsAppGroups[]> => {
  const response = await api.get("/whatsapp-v2-:stage/groups/list", {
    params: {
      client,
    },
  });

  return response.data.content;
};

export const contactsToPeople = async (
  instance_id: number,
): Promise<any> => {
  const response = await api.post("/whatsapp-v2-:stage/contacts/topeople", {
    instance_id
  });

  return response.data.content;
};

export const reserveInstance = async (
  client: number,
  instance_type: number
): Promise<any> => {
  const response = await api.post("/whatsapp-v2-:stage/instances/reserve", {
    client,
    instance_type,
  });

  return response.data.content;
};

export const findQrCode = async (client: number): Promise<any> => {
  const response = await api.post("/whatsapp-v2-:stage/zapi/qrcode/image", {
    client,
  });

  return response.data.content;
};

export const createInstance = async (
  data: CreateInstanceWhatsAppData
): Promise<any> => {
  const response = await api.post(
    "/whatsapp-v2-:stage/instances/client/create",
    data
  );

  return response.data.content;
};

export const updateInstance = async (
  data: UpdateInstanceWhatsAppData
): Promise<any> => {
  const requestObjectData = { ...data, store: data.store.id_loja };

  const response = await api.put(
    "/whatsapp-v2-:stage/instances/client/update",
    requestObjectData
  );

  return response.data.content;
};

export const deleteInstance = async (id: number): Promise<any> => {
  const response = await api.delete(
    "/whatsapp-v2-:stage/instances/client/delete",
    { data: { id } }
  );

  return response.data.content;
};
